<template>
  <a-skeleton :loading="loading" :title="false" :paragraph="{rows: 8, width: 800}">
    <div v-if="!has_backup_code">
      <p class="mfa-p">No backup code has been generated yet.</p>
      <a-button type="primary" shape="round" icon="download" size="large" @click="createBackupCodes">Generate Backup Codes</a-button>
    </div>
    <div v-else>
      <p class="mfa-p">Backup code has been generated. {{ has_backup_code.count_tokens }} out of 10 codes are available to use.</p>

    </div>
    
  </a-skeleton>
</template>
<script>
import { saveAs } from 'file-saver';
export default {
  data() {
    return {
      loading: true
    };
  },
  methods: {
    saveBackupCodes(codes) {
      var blob = new Blob([codes.join("\r\n")], {type: "text/plain;charset=utf-8"});
      saveAs(blob, "backup-codes.txt");
    },
    createBackupCodes: async function() {
      let uuid = this.$auth.session.id_payload.sub;
      try {
        let response = await this.$store.dispatch("axioms/createItem", {
          endpoint: "mfa/devices/static/users/"+uuid,
          data: {}
        });
        await this.$notification.success({
          message: "Backup codes generated!",
          description: "Please save backup codes at a safe place."
        });
        await this.saveBackupCodes(response.codes);
        await this.$store.dispatch("axioms/getItem", {
          endpoint: "mfa/devices/static/users",
          uuid: uuid
        });
      } catch (error) {
        console.error(error);
        await this.$notification.error({
          message: "Backup codes already exists.!",
          description: "Try to regenerate the codes if required."
        });
      }
    }
  },
  mounted: async function() {
    try {
      await this.$store.dispatch("axioms/getItem", {
        endpoint: "mfa/devices/static/users",
        uuid: this.$auth.session.id_payload.sub
      });
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  },
  computed: {
    has_backup_code() {
      return this.$store.state.axioms[
        "mfa/devices/static/users_item"
      ]
        ? this.$store.state.axioms[
            "mfa/devices/static/users_item"
          ]
        : false;
    },
  },
};
</script>